import capitalize from 'lodash/capitalize'

import { compareVersion } from '@/utils/version'

export const getCounters = (section, name) => {
  const counters = {
    unreadMessages: section.unreadMessages.length,
    privateUnreadMessages: section.privateUnreadMessages.length,
    total: (section.total?.length || 0) - (section.highlighted?.length || 0),
    totalHighlighted: section.highlighted?.length || 0
  }

  return {
    ...counters,
    key: `${name}-${Object.values(counters).join('-')}`
  }
}

export const mapStaffAsArray = staffObject =>
  Object.values(staffObject).map(item => {
    let fullName = item.name
    const description = capitalize(item.description)

    if (item.firstName) {
      fullName = [item.firstName, item.lastName].filter(Boolean).join(' ')
    }

    return {
      ...item,
      fullName,
      participantName: fullName,
      participantTooltip: `${fullName} - ${description}`,
      description
    }
  })

const getAppVersion = version => {
  const regex = /\d+\.\d+(\.\d+)?/g
  const matched = version.match(regex)
  if (matched) return matched[0]
  return null
}

export const checkAppVersion = (channelVersion, versionCompare) => {
  if (!channelVersion || !versionCompare) {
    return false
  }
  const version = getAppVersion(channelVersion)
  if (!version) return false

  return compareVersion(version, versionCompare) !== -1
}

export const shouldShowAllMessages = ({
  channel,
  featureFlagValue,
  staffCanViewAllMessages
}) => {
  if (!featureFlagValue || !channel?.createdAt?.seconds) return true

  const createdAt = channel.createdAt.seconds
  const featureFlagDate = new Date(featureFlagValue).getTime() / 1000

  return createdAt < featureFlagDate || staffCanViewAllMessages
}
